<template>
  <div class='Title' :style="style">{{data.controls.title}}</div>
</template>

<script>
export default {
  name: 'Title',

  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  computed: {
    style () {
      return {
        color: this.data.controls.textColor,
        fontSize: `${parseInt(this.data.controls.textSize) / 192}rem`,
        fontWeight: this.data.controls.textWeight,
        borderLeft: `${5 / 192}rem solid ${this.data.controls.textColor}`
      }
    }
  }
}
</script>

<style lang='stylus' scoped>
  .Title
    display flex
    align-items center
    text-indent 10px
    margin 20px 0
</style>
